export default __webpack_public_path__ + "static/media/rocket_anim_161.2f34a9d1.png";